import { jsx } from 'react/jsx-runtime';
import { CSSTransition } from 'react-transition-group';
import '../../utils/index_orig/index.esm.js';
import '../../utils/theme/theme-provider/index.esm.js';
import styles from '../../styles/uitk-egds-sheet.css';
import { classNames } from '../../utils/classnames/index.esm.js';
const getClassNameList = classNames.bind(styles);
const EGDSSheetTransition = props => {
  const {
    children,
    closeCallback,
    isVisible = false,
    openCallback
  } = props;
  const baseClassName = 'uitk-sheet';
  let enterTimeout;
  let exitTimeout;
  // Currently, sheet animation behavior is still being developed by design; as a result, many animation timings are hardcoded.
  // These values come from their respective sheet CSS files until their behavior is fully aligned.
  // See PR #6488 for more details.
  const sheetType = children.props.type;
  switch (sheetType) {
    case 'popover':
      enterTimeout = 180;
      exitTimeout = 60;
      break;
    case 'side':
      enterTimeout = 200;
      exitTimeout = 120;
      break;
    case 'bottom':
      enterTimeout = 275;
      exitTimeout = 275;
      break;
    default:
      // 275ms is the max transition time across sheets for entering and exiting.
      enterTimeout = 275;
      exitTimeout = 275;
  }
  return jsx(CSSTransition, {
    classNames: {
      enter: getClassNameList(`${baseClassName}-enter`),
      enterActive: getClassNameList(`${baseClassName}-enter-active`),
      exit: getClassNameList(`${baseClassName}-exit`),
      exitActive: getClassNameList(`${baseClassName}-exit-active`)
    },
    in: isVisible,
    unmountOnExit: true,
    timeout: {
      enter: enterTimeout,
      exit: exitTimeout
    },
    onEntered: openCallback,
    onExited: closeCallback,
    children: children
  });
};
EGDSSheetTransition.displayName = 'EGDSSheetTransition';
export { EGDSSheetTransition };